import * as React from 'react';
import { Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

export default function CustomLabel({ children }: { children: React.ReactNode }) {
  const theme = useTheme();
  const w = (theme as { weha?: Record<string, unknown> }).weha || {};
  return (
    <Typography
      variant="caption"
      style={{
        color: w.textMuted || theme.palette.text.secondary,
        fontWeight: 600,
        display: 'block',
        marginBottom: '6px',
        letterSpacing: '0.5px',
      }}
    >
      {children}
    </Typography>
  );
}
